import { useCallback, useEffect, useState } from "react";
import request from "superagent";
import { BACKEND_URL } from "../config/config";
import { UserAccountExtended } from "../types/UserAccount";
import useSessionToken from "./useSessionToken";

const cache: { [uuid: string]: UserAccountExtended | undefined } = {};

function useProfileDetails(uuid = "me"): UserAccountExtended | undefined {
  const sessionToken = useSessionToken();
  const [profile, setProfile] = useState<UserAccountExtended>();

  const loadProfileData = useCallback(() => {
    // eslint-disable-next-line no-prototype-builtins
    request
      .get(BACKEND_URL + `api/profile/${uuid}`)
      .set("Authorization", `Bearer ${sessionToken}`)
      .then((res) => {
        const profile = res.body;
        setProfile(profile);
      })
      .catch(() => {
        setProfile(undefined);
      });
  }, [sessionToken, uuid]);

  useEffect(() => {
    loadProfileData();
  }, [loadProfileData]);

  return profile;
}
export default useProfileDetails;
